import type { ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';

/** Superfície dos cards de escolha. O hover segue o card selecionável da lista: borda e fundo. */
export function choiceSurfaceClass(selected: boolean): string {
  return cn(
    'cursor-pointer rounded-2xl border p-4 text-left transition-[border-color,background-color] duration-200',
    'hover:border-primary/40 hover:bg-primary/[0.06]',
    'focus-within:ring-2 focus-within:ring-ring/50',
    selected ? 'border-primary/40 bg-primary/[0.06] ring-1 ring-primary/35' : 'border-border bg-card',
  );
}

/**
 * Card de rádio/checkbox. O clique no miolo seleciona uma vez.
 * O controle para o evento para não disparar de novo.
 * Botões internos, se existirem, ficam fora dessa seleção.
 */
export function ChoiceCard({
  selected,
  onSelect,
  control,
  children,
  actions,
  className,
}: {
  selected: boolean;
  onSelect: () => void;
  control: ReactNode;
  children: ReactNode;
  actions?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn(choiceSurfaceClass(selected), className)} onClick={onSelect}>
      <div className="flex items-start gap-3">
        <div className="shrink-0" onClick={(event) => event.stopPropagation()}>
          {control}
        </div>
        <div className="min-w-0 flex-1">{children}</div>
      </div>
      {actions ? (
        <div className="mt-3" onClick={(event) => event.stopPropagation()} onKeyDown={(event) => event.stopPropagation()}>
          {actions}
        </div>
      ) : null}
    </div>
  );
}
